import phoneNumberService from '../service/phoneNumberService';

export const normalizeChatClientId = (id: string) => {
  if (phoneNumberService.isValidPhoneNumber(id)) {
    return phoneNumberService.toPhoneNumberWithPlusSign(id).replace(/^\+/, '');
  }

  return String(id);
};

export const isSameChatClientIdentity = (
  a: Pick<{ id: string; senderId?: string }, 'id' | 'senderId'>,
  b: Pick<{ id: string; senderId?: string }, 'id' | 'senderId'>
) =>
  normalizeChatClientId(String(a.id)) === normalizeChatClientId(String(b.id)) &&
  String(a.senderId ?? '') === String(b.senderId ?? '');

export const getChatIdentityKey = (client: Pick<{ id: string; senderId?: string }, 'id' | 'senderId'>) =>
  `${String(client.senderId ?? '')}::${normalizeChatClientId(String(client.id))}`;
